import "./students.css";

import BaseTemplate from "../../../components/shared/BaseTemplate";
import { Outlet } from "react-router-dom";

export default function Students() {
  return (
    <BaseTemplate>
      <Outlet />
    </BaseTemplate>
  );
}
